// extracted by mini-css-extract-plugin
export default {"wrapper":"PlatformLayout_wrapper__qgmCw","wrapper_children":"PlatformLayout_wrapper_children__Hg62T"};